import { TCRColumnLayout } from "./TCRColumnLayout";
import { ThemeContext } from "./ThemeContext";

export const AlternativeInvestmentsCompany = (props) => (
	<ThemeContext.Provider
		value={{ linkText: "Start Investing", hasTrustPilotWidget: false }}
	>
		<TCRColumnLayout {...props} />
	</ThemeContext.Provider>
);
